// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  BodyCreateTaskResource,
  BodyPrepareTaskResourceFileUpload,
  GenericApiResponseBool,
  GenericApiResponseFileUploadUrlResponse,
  GenericApiResponseResource,
  GenericApiResponseUserResourceProgress,
  HTTPValidationError,
  ResourceLinkCreateRequest,
  ResourceUpdateRequest,
  UserResourceProgressUpdate,
} from '../../models';

/**
 * Prepare a file resource upload by getting a direct upload URL.

This endpoint generates a pre-signed URL that the client can use to upload
a file directly to Azure Blob Storage, bypassing the server. The server
creates a resource record in the pending_upload state and returns the URL
along with the resource ID.

After uploading the file to the URL, the client must call the complete-upload
endpoint to finalize the process.
 * @summary Prepare File Upload
 */
export const prepareTaskResourceFileUpload = (
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  bodyPrepareTaskResourceFileUpload: BodyPrepareTaskResourceFileUpload,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseFileUploadUrlResponse>> => {
  const formUrlEncoded = new URLSearchParams();
  formUrlEncoded.append('filename', bodyPrepareTaskResourceFileUpload.filename);
  formUrlEncoded.append('content_type', bodyPrepareTaskResourceFileUpload.content_type);
  if (bodyPrepareTaskResourceFileUpload.filesize !== undefined) {
    formUrlEncoded.append('filesize', bodyPrepareTaskResourceFileUpload.filesize.toString());
  }
  if (bodyPrepareTaskResourceFileUpload.title !== undefined && bodyPrepareTaskResourceFileUpload.title !== null) {
    formUrlEncoded.append('title', bodyPrepareTaskResourceFileUpload.title);
  }
  if (
    bodyPrepareTaskResourceFileUpload.description !== undefined &&
    bodyPrepareTaskResourceFileUpload.description !== null
  ) {
    formUrlEncoded.append('description', bodyPrepareTaskResourceFileUpload.description);
  }
  if (bodyPrepareTaskResourceFileUpload.citation !== undefined && bodyPrepareTaskResourceFileUpload.citation !== null) {
    formUrlEncoded.append('citation', bodyPrepareTaskResourceFileUpload.citation);
  }

  return axios.post(
    `/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/resources/files/prepare`,
    formUrlEncoded,
    options,
  );
};

export const getPrepareTaskResourceFileUploadMutationOptions = <
  TData = Awaited<ReturnType<typeof prepareTaskResourceFileUpload>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; data: BodyPrepareTaskResourceFileUpload },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['prepareTaskResourceFileUpload'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof prepareTaskResourceFileUpload>>,
    { moduleId: string; moduleVersion: string; taskId: string; data: BodyPrepareTaskResourceFileUpload }
  > = (props) => {
    const { moduleId, moduleVersion, taskId, data } = props ?? {};

    return prepareTaskResourceFileUpload(moduleId, moduleVersion, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; data: BodyPrepareTaskResourceFileUpload },
    TContext
  >;
};

export type PrepareTaskResourceFileUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof prepareTaskResourceFileUpload>>
>;
export type PrepareTaskResourceFileUploadMutationBody = BodyPrepareTaskResourceFileUpload;
export type PrepareTaskResourceFileUploadMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Prepare File Upload
 */
export const usePrepareTaskResourceFileUpload = <
  TData = Awaited<ReturnType<typeof prepareTaskResourceFileUpload>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; data: BodyPrepareTaskResourceFileUpload },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; moduleVersion: string; taskId: string; data: BodyPrepareTaskResourceFileUpload },
  TContext
> => {
  const mutationOptions = getPrepareTaskResourceFileUploadMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Complete a file upload process after the client has uploaded to Azure.

This endpoint is called by the client after successfully uploading a file
to the direct upload URL. It verifies the file exists in storage, updates
the resource status to active, and triggers any necessary background processing.
 * @summary Complete File Upload
 */
export const completeTaskResourceUpload = (
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  resourceId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseResource>> => {
  return axios.post(
    `/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/resources/${resourceId}/complete`,
    undefined,
    options,
  );
};

export const getCompleteTaskResourceUploadMutationOptions = <
  TData = Awaited<ReturnType<typeof completeTaskResourceUpload>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['completeTaskResourceUpload'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeTaskResourceUpload>>,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string }
  > = (props) => {
    const { moduleId, moduleVersion, taskId, resourceId } = props ?? {};

    return completeTaskResourceUpload(moduleId, moduleVersion, taskId, resourceId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
};

export type CompleteTaskResourceUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeTaskResourceUpload>>
>;

export type CompleteTaskResourceUploadMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Complete File Upload
 */
export const useCompleteTaskResourceUpload = <
  TData = Awaited<ReturnType<typeof completeTaskResourceUpload>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
  TContext
> => {
  const mutationOptions = getCompleteTaskResourceUploadMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Cancel an in-progress file upload and delete the resource.

This endpoint allows clients to cancel an upload that hasn't been completed yet.
It's useful for handling errors or when a user decides to cancel the upload.
 * @summary Cancel File Upload
 */
export const cancelTaskResourceUpload = (
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  resourceId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseBool>> => {
  return axios.delete(
    `/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/resources/${resourceId}/cancel`,
    options,
  );
};

export const getCancelTaskResourceUploadMutationOptions = <
  TData = Awaited<ReturnType<typeof cancelTaskResourceUpload>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['cancelTaskResourceUpload'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelTaskResourceUpload>>,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string }
  > = (props) => {
    const { moduleId, moduleVersion, taskId, resourceId } = props ?? {};

    return cancelTaskResourceUpload(moduleId, moduleVersion, taskId, resourceId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
};

export type CancelTaskResourceUploadMutationResult = NonNullable<Awaited<ReturnType<typeof cancelTaskResourceUpload>>>;

export type CancelTaskResourceUploadMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Cancel File Upload
 */
export const useCancelTaskResourceUpload = <
  TData = Awaited<ReturnType<typeof cancelTaskResourceUpload>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
  TContext
> => {
  const mutationOptions = getCancelTaskResourceUploadMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Create a new link resource for a task.

This endpoint creates a resource that points to an external URL
rather than an uploaded file.
 * @summary Create Resource Link
 */
export const createTaskResourceLink = (
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  resourceLinkCreateRequest: ResourceLinkCreateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseResource>> => {
  return axios.post(
    `/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/resources/links`,
    resourceLinkCreateRequest,
    options,
  );
};

export const getCreateTaskResourceLinkMutationOptions = <
  TData = Awaited<ReturnType<typeof createTaskResourceLink>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; data: ResourceLinkCreateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createTaskResourceLink'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaskResourceLink>>,
    { moduleId: string; moduleVersion: string; taskId: string; data: ResourceLinkCreateRequest }
  > = (props) => {
    const { moduleId, moduleVersion, taskId, data } = props ?? {};

    return createTaskResourceLink(moduleId, moduleVersion, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; data: ResourceLinkCreateRequest },
    TContext
  >;
};

export type CreateTaskResourceLinkMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskResourceLink>>>;
export type CreateTaskResourceLinkMutationBody = ResourceLinkCreateRequest;
export type CreateTaskResourceLinkMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Create Resource Link
 */
export const useCreateTaskResourceLink = <
  TData = Awaited<ReturnType<typeof createTaskResourceLink>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; data: ResourceLinkCreateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; moduleVersion: string; taskId: string; data: ResourceLinkCreateRequest },
  TContext
> => {
  const mutationOptions = getCreateTaskResourceLinkMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Re-run AI processing (digest generation) for a resource.

Best-effort enrichment (e.g. fetching a web page to build the AI digest) can fail
for reasons outside our control - a site blocks our scraper, times out, or changes.
This endpoint lets a lecturer retry it on demand. It forces a rebuild of the digest
and returns the resource immediately; the digest is regenerated in the background, so
the client should refetch shortly after to pick up the new outcome.
 * @summary Reprocess Resource
 */
export const reprocessTaskResource = (
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  resourceId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseResource>> => {
  return axios.post(
    `/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/resources/${resourceId}/reprocess`,
    undefined,
    options,
  );
};

export const getReprocessTaskResourceMutationOptions = <
  TData = Awaited<ReturnType<typeof reprocessTaskResource>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['reprocessTaskResource'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reprocessTaskResource>>,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string }
  > = (props) => {
    const { moduleId, moduleVersion, taskId, resourceId } = props ?? {};

    return reprocessTaskResource(moduleId, moduleVersion, taskId, resourceId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
};

export type ReprocessTaskResourceMutationResult = NonNullable<Awaited<ReturnType<typeof reprocessTaskResource>>>;

export type ReprocessTaskResourceMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Reprocess Resource
 */
export const useReprocessTaskResource = <
  TData = Awaited<ReturnType<typeof reprocessTaskResource>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
  TContext
> => {
  const mutationOptions = getReprocessTaskResourceMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Create a new resource for a task.

DEPRECATED: Please use /tasks/{task_id}/resources/files/prepare for file resources
or /tasks/{task_id}/resources/links for link resources instead.

This endpoint creates either a file resource or a link resource depending on
which parameters are provided.
 * @deprecated
 * @summary Create Resource
 */
export const createTaskResource = (
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  bodyCreateTaskResource: BodyCreateTaskResource,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseResource>> => {
  const formData = new FormData();
  if (bodyCreateTaskResource.file !== undefined && bodyCreateTaskResource.file !== null) {
    formData.append('file', bodyCreateTaskResource.file);
  }
  if (bodyCreateTaskResource.link_url !== undefined && bodyCreateTaskResource.link_url !== null) {
    formData.append('link_url', bodyCreateTaskResource.link_url);
  }
  if (bodyCreateTaskResource.title !== undefined && bodyCreateTaskResource.title !== null) {
    formData.append('title', bodyCreateTaskResource.title);
  }
  if (bodyCreateTaskResource.description !== undefined && bodyCreateTaskResource.description !== null) {
    formData.append('description', bodyCreateTaskResource.description);
  }
  if (bodyCreateTaskResource.citation !== undefined && bodyCreateTaskResource.citation !== null) {
    formData.append('citation', bodyCreateTaskResource.citation);
  }

  return axios.post(`/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/resources`, formData, options);
};

export const getCreateTaskResourceMutationOptions = <
  TData = Awaited<ReturnType<typeof createTaskResource>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; data: BodyCreateTaskResource },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createTaskResource'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTaskResource>>,
    { moduleId: string; moduleVersion: string; taskId: string; data: BodyCreateTaskResource }
  > = (props) => {
    const { moduleId, moduleVersion, taskId, data } = props ?? {};

    return createTaskResource(moduleId, moduleVersion, taskId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; data: BodyCreateTaskResource },
    TContext
  >;
};

export type CreateTaskResourceMutationResult = NonNullable<Awaited<ReturnType<typeof createTaskResource>>>;
export type CreateTaskResourceMutationBody = BodyCreateTaskResource;
export type CreateTaskResourceMutationError = AxiosError<HTTPValidationError>;

/**
 * @deprecated
 * @summary Create Resource
 */
export const useCreateTaskResource = <
  TData = Awaited<ReturnType<typeof createTaskResource>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; data: BodyCreateTaskResource },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; moduleVersion: string; taskId: string; data: BodyCreateTaskResource },
  TContext
> => {
  const mutationOptions = getCreateTaskResourceMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Update a resource's metadata and/or position.
 * @summary Update Resource
 */
export const updateTaskResource = (
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  resourceId: string,
  resourceUpdateRequest: ResourceUpdateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseResource>> => {
  return axios.put(
    `/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/resources/${resourceId}`,
    resourceUpdateRequest,
    options,
  );
};

export const getUpdateTaskResourceMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTaskResource>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string; data: ResourceUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateTaskResource'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTaskResource>>,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string; data: ResourceUpdateRequest }
  > = (props) => {
    const { moduleId, moduleVersion, taskId, resourceId, data } = props ?? {};

    return updateTaskResource(moduleId, moduleVersion, taskId, resourceId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string; data: ResourceUpdateRequest },
    TContext
  >;
};

export type UpdateTaskResourceMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaskResource>>>;
export type UpdateTaskResourceMutationBody = ResourceUpdateRequest;
export type UpdateTaskResourceMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Resource
 */
export const useUpdateTaskResource = <
  TData = Awaited<ReturnType<typeof updateTaskResource>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string; data: ResourceUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; moduleVersion: string; taskId: string; resourceId: string; data: ResourceUpdateRequest },
  TContext
> => {
  const mutationOptions = getUpdateTaskResourceMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete a resource.
 * @summary Delete Resource
 */
export const deleteTaskResource = (
  moduleId: string,
  moduleVersion: string,
  taskId: string,
  resourceId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseBool>> => {
  return axios.delete(
    `/modules/${moduleId}/versions/${moduleVersion}/tasks/${taskId}/resources/${resourceId}`,
    options,
  );
};

export const getDeleteTaskResourceMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteTaskResource>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteTaskResource'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTaskResource>>,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string }
  > = (props) => {
    const { moduleId, moduleVersion, taskId, resourceId } = props ?? {};

    return deleteTaskResource(moduleId, moduleVersion, taskId, resourceId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
};

export type DeleteTaskResourceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTaskResource>>>;

export type DeleteTaskResourceMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Resource
 */
export const useDeleteTaskResource = <
  TData = Awaited<ReturnType<typeof deleteTaskResource>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { moduleId: string; moduleVersion: string; taskId: string; resourceId: string },
  TContext
> => {
  const mutationOptions = getDeleteTaskResourceMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Update progress for a resource
 * @summary Update Resource Progress
 */
export const updateTaskResourceProgress = (
  courseId: string,
  moduleId: string,
  taskId: string,
  resourceId: string,
  userResourceProgressUpdate: UserResourceProgressUpdate,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseUserResourceProgress>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/resources/${resourceId}/progress`,
    userResourceProgressUpdate,
    options,
  );
};

export const getUpdateTaskResourceProgressMutationOptions = <
  TData = Awaited<ReturnType<typeof updateTaskResourceProgress>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; resourceId: string; data: UserResourceProgressUpdate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateTaskResourceProgress'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTaskResourceProgress>>,
    { courseId: string; moduleId: string; taskId: string; resourceId: string; data: UserResourceProgressUpdate }
  > = (props) => {
    const { courseId, moduleId, taskId, resourceId, data } = props ?? {};

    return updateTaskResourceProgress(courseId, moduleId, taskId, resourceId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; resourceId: string; data: UserResourceProgressUpdate },
    TContext
  >;
};

export type UpdateTaskResourceProgressMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTaskResourceProgress>>
>;
export type UpdateTaskResourceProgressMutationBody = UserResourceProgressUpdate;
export type UpdateTaskResourceProgressMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Resource Progress
 */
export const useUpdateTaskResourceProgress = <
  TData = Awaited<ReturnType<typeof updateTaskResourceProgress>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; resourceId: string; data: UserResourceProgressUpdate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; resourceId: string; data: UserResourceProgressUpdate },
  TContext
> => {
  const mutationOptions = getUpdateTaskResourceProgressMutationOptions(options);

  return useMutation(mutationOptions);
};
